export default __webpack_public_path__ + "static/media/ar-sidebar.2d681d7b.jpg";